const createBillPaymentTableCell = (value, row) => {
  switch (value) {
    case 'lender':
      return row._lender?.name;
    case 'servicer':
      return row._servicer?.name;
    case 'vendor':
      return row._vendor?.name;
    case 'borrower':
      return row._borrower?.entity_name === 'EIN'
        ? row._borrower?.entity_name
        : `${row._borrower?.first_name || ''} ${
            row._borrower?.last_name || ''
          }`;
    default:
      return '';
  }
};

export default createBillPaymentTableCell;
